/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  ReactElement,
  useState,
  ChangeEvent,
  useEffect,
  ReactNode,
} from 'react'
import parse from 'html-react-parser'
import { deepFind } from 'react-children-utilities'
import { StyledTextAdmin, StyledInputs } from './styled-components'
import Inputfield from '../../../input/input-field'
import { useAddTextAdminContext } from '../../../../contexts/add-text-admin'
import Icon from '../../../icon'
import Button from '../../../button'
import { SectionType } from '../../../../types/admin'

interface TextAdminProps {
  id: number
  value: SectionType['value']
  onDeleteClick?: () => void
}

function ImageAdmin({
  value,
  onDeleteClick,
  id,
}: TextAdminProps): ReactElement {
  const { addTextAdmin, setAddTextAdmin } = useAddTextAdminContext()

  const [url, setUrl] = useState('')
  const [size, setSize] = useState('')

  useEffect(() => {
    if (value) {
      const findDiv = deepFind(
        parse(value),
        (child: ReactNode) => (child as ReactElement).type === 'div'
      )

      const img = (findDiv as ReactElement).props.children

      if (img.props.src) setUrl(img.props.src)
      else setUrl('')
      if (img.props.style) {
        if (img.props.style.width.replace('rem', ''))
          setSize(img.props.style.width.replace('rem', ''))
        else setSize('')
      } else {
        setSize('')
      }
    }
  }, [])

  useEffect(() => {
    const html = `<div class="add-image"><img src = "${url}" style=" width:${size}rem; object-fit: contain; height: auto;"/></div>`
    const oldSections = [...addTextAdmin]
    const findIndexSection = oldSections.findIndex((e) => e.id === id)
    oldSections[findIndexSection].value = html
    setAddTextAdmin(oldSections)
  }, [url, size])

  return (
    <StyledTextAdmin>
      <>
        <StyledInputs>
          <Inputfield
            value={url}
            labelName="url"
            onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
              setUrl(event.target.value)
            }
            type="text"
          />
          <Inputfield
            value={parseInt(size, 10)}
            labelName="size"
            onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
              setSize(event.target.value)
            }
            type="number"
          />
        </StyledInputs>
      </>
      {onDeleteClick ? (
        <Button onClick={onDeleteClick} color="white">
          <Icon width={20} height={20} name="fluent:delete-28-regular" />
        </Button>
      ) : (
        <></>
      )}
    </StyledTextAdmin>
  )
}

export default ImageAdmin
